import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'
import type { CompanyCCJ } from '@/types/Activity'

const verifyOrganisationCreditMutation = gql`
  mutation (
    $customerId: String!
    $subjectId: String!
    $request: VerifyOrganisationCreditInput!
    $userId: String!
  ) {
    verifyOrganisationCredit(
      customerId: $customerId
      subjectId: $subjectId
      request: $request
      userId: $userId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  request: VerifyOrganisationRequest
}

export interface VerifyOrganisationRequest {
  creditScore: number
  creditLimit: number
  ccjs: CompanyCCJ[]
}

export type VerifyOrganisationCreditData = {
  verifyOrganisationCreditData: string | unknown
}

export const useVerifyOrganisationCreditMutation: WrappedMutation<
  VerifyOrganisationCreditData,
  MutationVars
> = () =>
  useMutation<VerifyOrganisationCreditData, MutationVars>(
    verifyOrganisationCreditMutation,
    {
      client: agentClient,
    },
  )
